var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('a-textarea',{staticStyle:{"resize":"none"},attrs:{"rows":12},model:{value:(_vm.codes),callback:function ($$v) {_vm.codes=$$v},expression:"codes"}}),_c('a-button',{staticStyle:{"margin-top":"8px"},attrs:{"type":"primary","block":""},on:{"click":_vm.searchGoods}},[_vm._v("查询")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }